import React, { useEffect } from 'react';
import { DynamicForm, PageFooter, PageHeader } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { useDefaultBrokerPageStore } from 'store/pages/enrollment/broker/broker-default/pageStore';
import { CARD_DATA } from 'global/checklists-helpers/ChecklistHelper';
import { SelectAgentForm } from 'components/common/enrollment/pick-producer/SelectAgentForm';

const PageContent: React.FC = observer(() => {
  const { getInitialData, producerDetailsForm, onBackRedirect, canCompleteStep, onComplete, selectProducerDelegate } =
    useDefaultBrokerPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <>
      <PageHeader
        title={CARD_DATA.DEFAULT_BROKER.title}
        subtitle={CARD_DATA.DEFAULT_BROKER.text}
        onBackButtonClick={onBackRedirect}
      />
      <SelectAgentForm selectProducerDelegate={selectProducerDelegate} />
      {selectProducerDelegate.selectedProducer || selectProducerDelegate.producerNotFound ? (
        <DynamicForm formDelegate={producerDetailsForm} showFooter={false} />
      ) : null}
      <PageFooter onBack={onBackRedirect} onComplete={onComplete} disableCompleteButton={!canCompleteStep} />
    </>
  );
});

export default PageContent;
